module.exports = __webpack_public_path__ + "1080p.svg?dff46550066cb4a76faabb4a56f0c67d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1080p.svg
// module id = 81
// module chunks = 0